import systemnotice from '@/api/sysmanagement/systemnotice';

const state = {
    systemNotices: []
};

const getters = {
    systemNotices(state) {
        return state.systemNotices;
    },
    hasSystemNotices(state) {
        return state.systemNotices.length > 0;
    }
}

const mutations = {
    systemNoticesSet(state, notices) {
        state.systemNotices = notices;
    },
    hideSystemNotice(state) {
        state.systemNotices = [];
    },
}

const actions = {
    async ['initSystemNotices']({
        commit
    }){
        const res = await systemnotice.getNoticeHomeList();

        commit('systemNoticesSet', res);
    },
    hideSystemNotice({commit}) {
        commit('hideSystemNotice');
    }
}


export default {
    state,
    getters,
    mutations,
    actions
  };


// WEBPACK FOOTER //
// ./src/store/modules/systemnotice.js